import React from "react";
import "./EmptyDataContainer.css";

const EmptyDataContainer = ({ message }) => {
  return <div className="empty-data-container">{message}</div>;
};

export default EmptyDataContainer;
